<template>
  <div>
    <b-card>
      <div slot="header">
        <strong>Ip detail</strong>
      </div>
      <b-row>
        <b-col md="6">
          <b-form-group class="text-primary" label="Active Use" label-for="ph_is_use">
            <c-switch color="info" label size="lg" id="ph_is_use" v-model="model.is_use" :disabled="lock" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group class="text-primary">
            <label>Ip Address</label>
              <b-form-textarea type="text" v-model="model.ip_address_list" :plaintext="lock" rows="3"
        max-rows="8"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <hr>
      <b-button size="sm" variant="secondary" @click="back"> Back </b-button>
      <template v-if="lock">
        <div class="float-right">
          <b-button size="sm" variant="primary" @click="edit"> Modify </b-button>
          <b-button size="sm" variant="danger" @click="confirm = true"> Delete </b-button>
        </div>
      </template>
      <template v-else>
        <div class="float-right">
          <b-button size="sm" variant="success" @click="save"> Save </b-button>
          <b-button size="sm" variant="secondary" @click="cancel"> Cancel </b-button>
        </div>
      </template>
    </b-card>
    <b-modal title="Confirm - Delete user account" class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      Deleted data cannot be reversed. Are you sure?
    </b-modal>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import { api, auth } from '@/f1/service';
import 'vue-select/dist/vue-select.css';
import _ from 'lodash';
import reg from '@/f1/reg';

const default_model = () => ({
  is_use: true
});

export default {
  components: { cSwitch, vSelect },
  data : () => ({
      confirm: false,
      add: false,
      lock: true,
      model : default_model(),
      profile: auth.profile,
  }),
  computed: {
    last_info() { return `${this.$options.filters.sdate(this.model.last_visit)} @ ${this.model.last_addr}`; }
  },
  methods: {
    cancel() { this.$router.replace({ name: 'ip', params: { id: this.model.id }}); },
    edit() { this.$router.replace({ name: 'ip', params: { id: this.model.id, tag: 'edit' }}); },
    async remove() {
      try {
        await api.ip.delete(this.model.id);
        this.$emit('refresh'); this.$toastr.s('License deleted.'); this.list();
      } catch(e) { this.$toastr.e(e.data || e); this.list(); }
    },
    back() { this.$router.go(-1); },
    list() { this.$router.push({ name: 'ip'}); },
    regex_valid: (c, f = '') => {
      if(!c) { return false }
      try { new RegExp(c, f); return true } catch(e) { return false }
    },
    validate_ip(ips) {
      let ip_list = typeof ips == 'string' ? (ips || '').split('\n') : ips;
      let rv = [];
      let false_rv = [];
      _.forEach(ip_list, ip => {
        ip = ip.replace(/\t/g,'');

        if(reg.ip4.test(ip) || reg.ip4_range.test(ip) || reg.ip6.test(ip)) {
          if(reg.ip_special_range.test(ip)){
            rv.push(ip);
          } else {
            false_rv.push(ip);
          }
        } else {
          false_rv.push(ip);
        }
      })

      if(false_rv.length > 0){
        alert("형식에 맞지 않는 ip주소는 제거됨 : " + false_rv.join('\n'));
      }

      return rv;
    },
    async save() {
      try {
        //배열의 falsy한 값[ false, null, 0, "", undefined, NaN ]을 제거하고 중복 제거
        this.model.ip_address_list = _.uniq(_.compact(this.model.ip_address_list.replace(/,/g, '').split("\n")));
        //ip정규식 검사
        this.model.ip_address = this.validate_ip(this.model.ip_address_list);
        this.model.ip_address_list = _.join(this.model.ip_address, '\n'); //ip_address_list에 배열이 아닌 값을 넣어야함.
        if(this.model.ip_address.length == 0) { return this.$toastr.e('Ip Address required.'); }
        if(this.model.id) {
          await api.ip.update(this.model);
        }
        else {
          this.model.id = +(await api.ip.add(this.model));
        }
        this.$toastr.s('Done.'); this.$emit('refresh'); this.cancel();
      } catch(e) { this.$toastr.e(e.data || e); this.cancel(); }
      this.lock = true;
    },
    async get({ id, tag } = this.$route.params) {
      console.log('[vue] ip.detail', 'load item', id);

      if(id === 'add') { this.add = true; this.lock = false; this.model = default_model(); return; }
      else { this.add = false; }

      this.lock = (tag !== 'edit');
      try {
        this.model = Object.assign({}, this.model, await api.ip.get(id));
        this.model.ip_address_list = this.model.ip_address ? this.model.ip_address.join("\n") : ''
      }
      catch(e) { console.log(e); this.$toastr.e(e.data || e); this.list(); }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params); console.log(from) } },
  created() { },
  destroyed() { },
  mounted() {
    this.get(this.$route.params);
  }
}
</script>
